import { initApiButtons } from "../utils.js";
function run() {
    $(() => {
        console.log('Initialized Page Script...');
        initApiButtons();
    });
}
export const page_enlistments = {
    requiresAuth: true,
    run: run,
};
//# sourceMappingURL=enlistments.js.map